class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.modalContent = this.querySelector('.modal__content');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    const clickedOverlay = event.target.classList.contains('modal-overlay');
    const clickedModal = this.modalContent?.contains(event.target);
    if (clickedOverlay || (!this.contains(event.target) && !clickedModal)) this.close(false);
  }

  portalModal() {
    if (!this.modalContent || this.modalPlaceholder) return;

    this.modalPlaceholder = document.createComment('details-modal-portal');
    this.modalContent.before(this.modalPlaceholder);
    document.body.append(this.modalContent);
    this.modalContent.classList.add('modal__content--portal');
    if (this.modalContent.classList.contains('search-modal')) this.modalContent.classList.add('search-modal--portal');
    this.modalContent.dataset.open = 'true';
  }

  restoreModal() {
    if (!this.modalContent || !this.modalPlaceholder) return;

    this.modalPlaceholder.replaceWith(this.modalContent);
    this.modalPlaceholder = null;
    this.modalContent.classList.remove('modal__content--portal');
    this.modalContent.classList.remove('search-modal--portal');
    delete this.modalContent.dataset.open;
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.onKeyUpEvent = this.onKeyUpEvent || ((keyEvent) => keyEvent.code.toUpperCase() === 'ESCAPE' && this.close());
    event.target.closest('details').setAttribute('open', true);
    const focusTarget = this.modalContent?.querySelector('[tabindex="-1"]');
    const focusInput = this.modalContent?.querySelector('input:not([type="hidden"])');
    this.portalModal();
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.addEventListener('keyup', this.onKeyUpEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(focusTarget, focusInput);
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.removeEventListener('keyup', this.onKeyUpEvent);
    document.body.classList.remove('overflow-hidden');
    this.restoreModal();
  }
}

customElements.define('details-modal', DetailsModal);
